import React from "react"
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";

import App from "../components/App/App";

const resolver = () => {
    if (window.env.REACT_APP_ROUTE_PREFIX === '/' || window.env.REACT_APP_ROUTE_PREFIX === undefined) {
        return ''
    }
    return `${window.env.REACT_APP_ROUTE_PREFIX}`
}

export const prefix = resolver()

const AppRouter = () => {
    return <>
        <BrowserRouter basename={prefix}>
            <Routes>
                <Route path="/" element={<App/>}/>                
            </Routes>
        </BrowserRouter>
    </>
}

export default AppRouter